import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import {
  baseUrl,
  customHeaders,
  commsHeader,
  indianProjectsBaseURL,
  uaeProjectsBaseURL,
  ksaProjectsBaseURL,
  thriweMarketPlaceUrl,
  alrajhiValetURL,
} from '../../../../Containers/Config/index.js';

import { VENDOR_BOOKINGS_DATA_ALRAJHI, VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI, VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* GetVendorBookingsAlrajhi({ payload }) {
  let projectBaseURL = payload?.headers?.code === 'SCB_V1' ? thriweMarketPlaceUrl : alrajhiValetURL;

  try {
    const response = yield call(apiCall, {
      url: `${projectBaseURL}/v3/vendor/bookings`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': payload?.headers?.code,
      },
      // params: {
      //   // bookingTypeId: payload?.urlParam?.bookingTypeId,
      //   // pageIndex: payload?.urlParam?.pageIndex,
      //   pageSize: Constant?.TABLE_PAGE_SIZE,
      //   // sortOn: payload?.urlParam?.sortOn,
      //   ...payload?.urlParam,
      // },
      // data: payload?.body,
      // data: payload?.data,
      data: {
        ...payload?.body,
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      yield put({ type: VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI, payload: error });
  }
}

export function* watchGetVendorBookingsAlrajhi() {
  yield takeEvery(VENDOR_BOOKINGS_DATA_ALRAJHI, GetVendorBookingsAlrajhi);
}

function* vendorBookingsSagaAlrajhi() {
  yield all([fork(watchGetVendorBookingsAlrajhi)]);
}

export default vendorBookingsSagaAlrajhi;
